import {
    CREATE_TRAVEL_URL,
    UPDATE_TRAVEL_URL,
    GET_TRAVEL_DETAILS_BY_CREATED_BY_URL,
    FIND_SIMILAR_TRAVELS_URL
} from "../utils/api-url";
import { postCall } from "../utils/network.util";
import { isValid, isValidNumber } from "../utils/utilities";

const handleResponse = (data, onSuccess, onFailure) => {
    if (data && data.status === "SUCCESS") {
        const clientPayload = data.payload;
        if (clientPayload && clientPayload.Status === "SUCCESS") {
            onSuccess(clientPayload.Payload, clientPayload.Message);
            return;
        }
        onFailure(clientPayload && clientPayload.Message ? clientPayload.Message : "Request failed");
        return;
    }
    onFailure("Request failed");
};

export const getBusOperatorsByCreatedBy = (onSuccess = () => {}, onFailure = () => {}) => {
    return postCall(GET_TRAVEL_DETAILS_BY_CREATED_BY_URL, {
        createdBy: global.userName
    }).then((data) => {
        handleResponse(
            data,
            (payload) => {
                onSuccess(payload && Array.isArray(payload.travelsInfo) ? payload.travelsInfo : []);
            },
            onFailure
        );
    }).catch((reason) => {
        console.error("getBusOperatorsByCreatedBy failed", reason);
        onFailure("Failed to fetch bus operators");
    });
};

export const findSimilarBusOperators = ({ operatorCode, name }, onSuccess = () => {}, onFailure = () => {}) => {
    return postCall(FIND_SIMILAR_TRAVELS_URL, {
        operatorCode: isValid(operatorCode) ? operatorCode.toUpperCase() : operatorCode,
        name
    }).then((data) => {
        handleResponse(
            data,
            (payload) => {
                onSuccess(payload && Array.isArray(payload.travelsInfo) ? payload.travelsInfo : []);
            },
            onFailure
        );
    }).catch((reason) => {
        console.error("findSimilarBusOperators failed", reason);
        onFailure("Failed to check similar bus operators");
    });
};

export const createBusOperator = ({ name, operatorCode, websiteUrl, region }, onSuccess = () => {}, onFailure = () => {}) => {
    return postCall(CREATE_TRAVEL_URL, {
        travelInfo: {
            name,
            operatorCode: isValid(operatorCode) ? operatorCode.toUpperCase() : operatorCode,
            websiteUrl,
            region,
            createdBy: global.userName
        }
    }).then((data) => {
        handleResponse(data, (_, msg) => onSuccess(msg), onFailure);
    }).catch((reason) => {
        console.error("createBusOperator failed", reason);
        onFailure("Failed to create bus operator");
    });
};

// Only operator name, website url and active status are allowed to change after creation.
export const updateBusOperator = ({ operatorCode, name, websiteUrl, isActive }, onSuccess = () => {}, onFailure = () => {}) => {
    const travelInfo = {
        name,
        websiteUrl
    };
    if (isValidNumber(isActive)) {
        travelInfo.isActive = isActive;
    }
    return postCall(UPDATE_TRAVEL_URL, {
        operatorCode,
        travelInfo
    }).then((data) => {
        handleResponse(data, (_, msg) => onSuccess(msg), onFailure);
    }).catch((reason) => {
        console.error("updateBusOperator failed", reason);
        onFailure("Failed to update bus operator");
    });
};
